import { NgModule } from '@angular/core';
import { LongNumber } from '@shared/pipes/number-long.pipe';
import { ShortDate } from '@shared/pipes/short-date.pipe';

import { MomentFullDate, OrdinalNumberPipe } from './date.pipe';
import { DotDatePipe } from './dot-date.pipe';

@NgModule({
	declarations: [MomentFullDate, OrdinalNumberPipe, LongNumber, ShortDate, DotDatePipe],
	exports: [OrdinalNumberPipe, MomentFullDate, LongNumber, ShortDate, DotDatePipe],
})
export class PipesModule {}
